import me from "models/me";

export default function (_nextState, replace, callback) {
    if (!me.hasMerchantOrganization()) {
        replace({
            pathname: "/404",
        });
    }
    callback();
}
